// Talks to YOUR routing server (server/ folder): OSRM for roads, a Nominatim proxy for addresses.
import { ROUTING_URL, ROUTING_KEY } from './config.js';

function url(path, params = {}) {
  if (!ROUTING_URL) throw new Error('Routing server not configured (VITE_ROUTING_URL).');
  const u = new URL(ROUTING_URL + path);
  Object.entries(params).forEach(([k, v]) => u.searchParams.set(k, v));
  if (ROUTING_KEY) u.searchParams.set('key', ROUTING_KEY);
  return u.toString();
}

async function getJson(u, what) {
  let res;
  try { res = await fetch(u, { headers: { Accept: 'application/json' } }); }
  catch { throw new Error(`${what}: cannot reach the routing server. Check the internet connection.`); }
  if (res.status === 429) throw new Error(`${what}: too many requests, wait a minute and retry.`);
  if (!res.ok) throw new Error(`${what}: server error ${res.status}.`);
  return res.json();
}

const coords = pts => pts.map(p => `${p.lng},${p.lat}`).join(';');

/** Driving distance matrix in metres. */
export async function osrmTable(pts) {
  const js = await getJson(url(`/route/table/v1/driving/${coords(pts)}`, { annotations: 'distance' }), 'Distance matrix');
  if (js.code !== 'Ok') throw new Error('Routing failed: ' + js.code);
  return js.distances;
}

/** Full route through pts in order: {distance, duration, legs, geometry(GeoJSON)}. */
export async function osrmRoute(pts) {
  const js = await getJson(url(`/route/route/v1/driving/${coords(pts)}`, { overview: 'full', geometries: 'geojson' }), 'Route');
  if (js.code !== 'Ok') throw new Error('Could not draw route: ' + js.code);
  return js.routes[0];
}

/** Address search, limited to Bengaluru. Returns [{label, lat, lng}] (max 5). */
export async function geocode(q) {
  if (!/bengaluru|bangalore/i.test(q)) q += ', Bengaluru, Karnataka, India';
  const js = await getJson(url('/geocode/search', {
    format: 'jsonv2', limit: 5, countrycodes: 'in', viewbox: '77.40,13.20,77.85,12.75', bounded: 1, q,
  }), 'Address search');
  return js.map(r => ({ label: r.display_name, lat: +r.lat, lng: +r.lon }));
}
